<template>
    <div :class="itemData.scheduleName.includes('全国') ? 'national' : ''">
        <div
            shadow="hover"
            class="system-btn"
            :class="
                this.hasPerms(
                    itemData.authorityFlag
                        ? itemData.authorityFlag
                        : itemData.flag
                ) === true
                    ? ( itemData.icon ? ('card-background' + (itemIndex + 1)) : 'card-background')
                    : 'card-backgroundgray'
            "
        >
            <i v-if="itemData.icon" class="icon iconfont" :class="itemData.icon"></i>
            <div class="flex-center">
              <div>
                <div class="schedule_gameName" :class="itemData.icon ? '' : 'w120'">
                    {{ itemData.scheduleName }}
                </div>
                <div class="en">
                  {{ itemData.scheduleEnName }}
                </div>
              </div>
              <div class="btns">
                <div class="btn btn1" @click="scheduleCardTap(itemData, 1)" v-if="type === 'sale'">报名列表</div>
                <div class="btn btn1" @click="scheduleCardTap(itemData, 2)" v-if="type === 'sale' && (itemData.scheduleFlag === 'CITY_FINALS' || itemData.scheduleFlag === 'WEB_FINALS')">国赛缴费审核</div>
                <div class="btn btn1" @click="scheduleCardTap(itemData, 1)" v-if="type === 'deliver'">资格查询</div>
                <div class="btn btn1" @click="scheduleCardTap(itemData, 2)" v-if="type === 'deliver'">成绩查询</div>
                <div class="btn btn1" v-if="type === 'deliver'" @click="tapFn">学术资料</div>
                <div class="btn btn1" v-if="type === 'deliver'" @click="tapFn">设计资料</div>
              </div>
                <div class="schedule_gameNumber">
                    {{ itemData.descStr }}
                </div>
            </div>
            <!-- <img v-if="!itemData.icon" class="logo" :src=" itemData.scheduleName.includes('全国') ? 'https://cdn.spbcn.org/spbcnWeb/spbcn/logo-season12-icon.png' : 'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png'" alt=""> -->
            <img v-if="!itemData.icon" class="logo" :src="'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png'" alt="">
        </div>
    </div>
</template>

<script>
import { hasPermission } from '@/permission/index.js'
export default {
  props: {
    itemData: {
      type: Object,
      default: function () { return {} }
    },
    itemIndex: {
      type: Number
    },
    isItso: {
      type: Boolean
    },
    type: {
      type: String // deliver交付中心 sale销售中心
    }
  },
  methods: {
    scheduleCardTap (itemData, type) {
      if (this.hasPerms(itemData.authorityFlag ? itemData.authorityFlag : itemData.flag)) {
        if (type === 1) {
          this.$emit('itemClicked', itemData)
        } else if (type === 2) {
          this.$emit('itemClicked2', itemData)
        }
      } else {
        this.$message.warning('暂无操作权限')
      }
    },
    tapFn () {
      this.$message.warning('暂未开放')
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms) // & !this.disabled
    }
  }
}
</script>

<style lang="less" scoped>
.system-btn {
    border-radius: 10px;
    padding: 14px 0;
    margin-right: 20px;
    color: #fff;
    display: flex;
    // align-items: center;
    position: relative;
    // width: 260px;
    .icon {
        padding: 8px 10px;
        margin-left: 20px;
       font-size: 30px;
        background-color: rgba(255, 255, 255, 0.7);
        border-radius: 100%;
    }
    .schedule_gameName {
        text-align: left;
        color: #000;
        font-size: 18px;
        font-weight: 600;
        // margin-bottom: 6px;
        margin-left: 20px;
        &.w120{
          width: 160px;
        }
    }
    .en{
      font-size: 10px;
      font-weight: bold;
      margin-left: 20px;
      color: #000;
    }
    .flex-center{
      //
    }

    .btns{
      // height: 30px;
      margin-left: 14px;
      margin-top: 12px;
      .btn{
        display: inline-block;
        min-width: 66px;
        padding: 0 10px;
        box-sizing: border-box;
        height: 24px;
        text-align: center;
        line-height: 24px;
        border-radius: 6px;
        margin-right: 10px;
        margin-top: 6px;
        font-size: 12px;
        cursor: pointer;
        color: #fff;
        background-color: rgb(7, 17, 96);
        &:hover{
          box-shadow: inset 0 0 10px rgba(50, 72, 241, 0.8);
          color: rgb(7, 17, 96);
          background-color: #fff;
        }
      }
    }

    .schedule_gameNumber {
        text-align: left;
        color: white;
        font-size: 12px;
        margin-left: 20px;
    }
    &:hover{
      .schedule_gameName{
        // text-decoration: underline;
      }
      box-shadow: 0 4px 12px 0 rgba(0,0,0,.5);
    }
    .logo{
      position: absolute;
      right: 0;
      top: 10px;
      height: 50px;
      right: 10px;
    }
}
.national .logo{
  // height: 54px;
  // top: 26px;
  right: 6px;
}
.card-background{
  // background-color:  #011A52;
  background: linear-gradient(140deg, #97a1fb 0%, #fff 70%, #fff 100%);
  border-top: 6px solid #0B177C;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
}
// .national .card-background{
//   background-image: linear-gradient(to right, #040A4A, #122AC9);
// }
</style>
